module.exports = __webpack_public_path__ + "img/apple-app-store.e1f18429.svg";